import React, { useEffect, useState, useCallback, useTransition } from "react";
import { Modal, Form, Input, Cascader } from "antd";
import "../modal.scss";
import { useTranslation } from "react-i18next";
export interface IAddressModalProps {
  title: string;
  hiddenModal: () => void;
  addressInfo?: Address;
  submitAction: (params) => void;
}

const Address4Personal: React.FC<IAddressModalProps> = ({
  hiddenModal,
  title,
  addressInfo,
  submitAction,
}) => {
  const [form] = Form.useForm();
  const [addressOptions, setAddressOptions] = useState([]);
  const [isPending, startTransition] = useTransition();

  const { t } = useTranslation();

  const convertJson2Data = useCallback(async () => {
    const addressJson = await import("./address.json");
    const { default: address } = addressJson;
    const worker = new Worker(new URL("./worker.ts", import.meta.url));
    worker.onmessage = (e) => {
      setAddressOptions(e.data);
      worker.terminate(); // 关闭 worker
    };

    worker.postMessage(address);
  }, []);

  useEffect(() => {
    startTransition(() => {
      convertJson2Data();
    });
  }, []);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        values.province = values.address[0];
        values.city = values.address[1];
        values.area = values.address[2];
        delete values.address;
        submitAction(values);
        hiddenModal();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (addressInfo) {
      // setHasAddressInfo(true);
      form.setFieldValue("address", [
        addressInfo.province,
        addressInfo.city,
        addressInfo.area,
      ]);
    }
  }, [addressInfo]);

  return (
    <Modal
      open
      wrapClassName="modal-wrapper"
      onCancel={hiddenModal}
      footer={
        <>
          <button className="cancel" onClick={hiddenModal}>
            {t("取消")}
          </button>
          <button className="done" onClick={handleSubmit}>
            {t("提交")}
          </button>
        </>
      }
      width="46.667rem"
      title={t(title)}
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        colon={false}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        style={{ width: "90%" }}
        labelAlign="left"
        initialValues={addressInfo || { type: 2 }}
      >
        <Form.Item name="id" style={{ display: "none" }}>
          <div></div>
        </Form.Item>
        <Form.Item
          name="contact_person_name"
          label={t("收件人姓名")}
          rules={[
            {
              required: true,
              message: `${t("收件人姓名")} ${t("不能为空")}`,
            },
          ]}
        >
          <Input placeholder={t("必填")} autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="contact_telephone"
          label={t("收件人手机号")}
          rules={[
            {
              required: true,
              message: `${t("收件人手机号")} ${t("不能为空")}`,
            },
          ]}
        >
          <Input placeholder={t("必填")} autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="address"
          label={t("收件地址")}
          rules={[
            { required: true, message: `${t("收件地址")} ${t("不能为空")}` },
          ]}
        >
          <Cascader options={addressOptions} placeholder={t("必填")} />
        </Form.Item>
        <Form.Item
          name="detail_address"
          label={t("详细地址")}
          rules={[
            { required: true, message: `${t("详细地址")} ${t("不能为空")}` },
          ]}
        >
          <Input placeholder={t("必填")} autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="email"
          label={t("收件人邮箱")}
          rules={[
            { type: "email", message: `${t("收件人邮箱")}${t("格式不对")}` },
          ]}
        >
          <Input placeholder={t("选填")} autoComplete="off" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Address4Personal;
